import React from 'react';
import flagImage from '@assets/icons/forecastIconWhite.svg';
import {
  AccordionCollpaseContent,
  QuarterHeaderCollapseTitle,
} from '@atoms/sidebar/sidebar.styles';
import Legend from '@molecules/pursuitLeader/components/legend';

const QuarterlyCollapsedSidebar = props => {
  let legendData;
  const data = props?.data;
  const quarter = props?.quarter;
  const quarterTitle = props?.quarterTitle;

  quarterTitle === 'BEYOND'
    ? (legendData = data['months'][0].calculation)
    : (legendData = data['quarterlyCalculation']);

  return (
    <>
      <QuarterHeaderCollapseTitle>{quarterTitle}</QuarterHeaderCollapseTitle>
      <AccordionCollpaseContent>
        <Legend
          quarterlyData={legendData}
          quarterText={quarter}
          flagImageSrc={flagImage}
          quarterTitle={quarterTitle}
        />
      </AccordionCollpaseContent>
    </>
  );
};

export default QuarterlyCollapsedSidebar;
